module.exports = __webpack_public_path__ + "img/tp-card-blank-visa.515ea104.png";